(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/accordion/assets/javascripts/animations.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/accordion/assets/javascripts/animations.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (animations)
  });
  ; 
  const external_gsap_namespaceObject = window["gsap"];
  var external_gsap_default = __webpack_require__.n(external_gsap_namespaceObject);
  ; 
  const TUR = {
    DUR_OPEN: 0.85,
    DUR_CLOSE: 0.15,
    DELAY: 0,
    EASING: 'elastic.out(1, 0.75)'
  };
  const NEUTRAL = TUR;
  const SPORT = {
    DUR_OPEN: 0.15,
    DUR_CLOSE: 0.1,
    DELAY: 0,
    EASING: 'power1.out'
  };
  const constants = {
    TUR,
    SPORT,
    NEUTRAL
  };
  ; 


  const getAnimationSettings = customer => constants["".concat(customer.toUpperCase())] || constants.NEUTRAL;
  const toggleAccordionAnimate = (customer, expanded, el) => {
    if (el) {
      const animSettings = getAnimationSettings(customer);
      if (expanded) {
        el.children[1].classList.remove('accordion-details-closed');
      }
      external_gsap_default().to(el, {
        margin: expanded ? '12px 0 12px 0' : '-1px 0 0 0',
        duration: animSettings.DUR_OPEN,
        ease: animSettings.EASING,
        delay: 0
      });
      external_gsap_default().to(el.children[1], {
        height: expanded ? 'auto' : 0,
        duration: expanded ? animSettings.DUR_OPEN : animSettings.DUR_CLOSE,
        delay: animSettings.DELAY,
        ease: expanded ? animSettings.EASING : 'power1.out',
        onComplete: () => {
          if (!expanded) {
            el.children[1].classList.add('accordion-details-closed');
          }
        }
      });
      external_gsap_default().to(el.querySelector('.js-accordion-icon-animate'), {
        rotate: expanded ? 180 : 0,
        duration: animSettings.DUR_OPEN,
        delay: animSettings.DELAY,
        ease: animSettings.EASING
      });
    }
  };

  const handleNeighbors = (el, expanded, index) => {
    if (expanded) {
      el.parentElement.querySelector(".js-accordion-item-".concat(index - 1)) && el.parentElement.querySelector(".js-accordion-item-".concat(index - 1)).classList.add('accordion-radius-bottom');
      el.parentElement.querySelector(".js-accordion-item-".concat(index + 1)) && el.parentElement.querySelector(".js-accordion-item-".concat(index + 1)).classList.add('accordion-radius-top');
    } else {
      if (el && el.parentElement) {
        el.parentElement.querySelector(".js-accordion-item-".concat(index - 1)) && el.parentElement.querySelector(".js-accordion-item-".concat(index - 1)).classList.remove('accordion-radius-bottom');
        el.parentElement.querySelector(".js-accordion-item-".concat(index + 1)) && el.parentElement.querySelector(".js-accordion-item-".concat(index + 1)).classList.remove('accordion-radius-top');
      }
    }
  };
  const animations = {
    toggleAccordionAnimate,
    handleNeighbors
  };
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).Accordion = window.svs.ui.Accordion || {}).AccordionAnimations = __webpack_exports__["default"];
})();

 })(window);